import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SF_EPC_MGMT_SRCH, SG_EPC_MGMT_LST } from "./services/ComnCdService";
import { Link } from "react-router-dom";
export const EpcCodeList = (props: any) => {
    useResource({
        defaultSchema: [{ area: "epcCd" }],
    });
    /*
     * Mandatory Attached Docs List by HS
     * !== Mandatory Attached Docs List by HS 목록 조회 ==!
     */
    const pgeUid = "UI-CLRI-0402-001Q"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /**
     * EPC Form
     * !==폼 정의 ==!
     */
    const form = {
        //Epc Code Search !== EPC 코드 검색 ==!
        epcSrch: useForm({
            defaultSchema: SF_EPC_MGMT_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    /*
     * EPC Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Epc Code List !== EPC 코드 목록 ==!
        epcList: useGrid({
            defaultSchema: SG_EPC_MGMT_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * EPC Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get EPC Code List !== EPC 코드 목록 조회 ==!
        getEpcList: useFetch({
            api: (page = grid.epcList.page) => {
                form.epcSrch.setValue("useYn", "Y");
                return APIS.getEpcMgmtList(form.epcSrch.getValues(), page, grid.epcList.size);
            },
            enabled: true,
            key: [grid.epcList.page, grid.epcList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.epcSrch.getValues(),
                    page: grid.epcList.page,
                    size: grid.epcList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * EPC Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */

    const handler = {
        //Get EPC Code List !== EPC 코드 목록 조회 ==!
        getEpcList: () => {
            form.epcSrch.handleSubmit(
                (data) => {
                    fetch.getEpcList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        grid_EpcList: {
            cell: {
                epcCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.epcDesc, rowData: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    /*
     * EPC Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getEpcList();
    }, []);

    return (
        <>
            <Page title={t("T_EPC_CD_LST")} info={true}>
                <>
                    <Group>
                        <Group.Body>
                            <form>
                                <Group.Section>
                                    <Group.Row>
                                        {/* EPC !== EPC ==! */}
                                        <Group.Control {...form.epcSrch.schema.epcCd} />
                                        <Group.Control {...form.epcSrch.schema.epcDesc} />
                                    </Group.Row>
                                </Group.Section>
                            </form>
                            <Layout direction="row">
                                <Layout.Right>
                                    <Button
                                        role="search"
                                        onClick={() => {
                                            handler.getEpcList();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        </Group.Body>
                    </Group>

                    <Group>
                        <Group.Body>
                            <Grid
                                {...grid.epcList.grid}
                                data={fetch.getEpcList.data?.epcMgmtList}
                                render={render.grid_EpcList}
                            />
                        </Group.Body>
                    </Group>
                </>
            </Page>
        </>
    );
};
